import { Expose } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString } from "class-validator";

export class Cashbox {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsString()
  currency!: string;
  @Expose()
  @IsOptional()
  @IsString()
  accountingNumber!: string | null;
  @Expose()
  @IsBoolean()
  isSelected!: boolean;
}
